import React, { useState } from 'react';
import { Form,Button,  Row, Col,Table,Alert, Spinner,InputGroup} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { postDataLogin } from '../ApiServices/ApiService';
import { FaDownload } from 'react-icons/fa';
import NavHeader from './NavHeader';




const DashboardPage = () => {
  const [dataList, setDataList] = useState([]);
  const navigate = useNavigate();
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const[tableFlag,setTableFlag]=useState(true);
  const[candidatesFlag,setCandidateFlag]=useState(false)
  const [validated, setValidated] = useState(false);
  const[inputJobValue,setInputJobValue]=useState('')

  const [candidate, setCandidate] = useState({
    name: '',
    email: '',
    countryCode: '+1',
    phoneNumber: '',
    jobId:'',
    recruiterQuestions:""
  });
  const [showTextArea, setShowTextArea] = useState(false);

  const handleCheckBoxChange = (e) => {
    setShowTextArea(e.target.checked);
    candidate.recruiterQuestions="";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCandidate((prevCandidate) => ({
      ...prevCandidate,
      [name]: value,
    }));
  };

  const numberChange =(event)=>{
    const inputValue = event.target.value;
  if (!/[A-Z!@#$%^&*()_+{}\[\]:;<>,.?~=/\\-]/.test(inputValue) && !/[a-z]/.test(inputValue)) {
    const { name, value } = event.target;
    setCandidate((prevCandidate) => ({
      ...prevCandidate,
      [name]: value,
    }))
    
  }
  else {
    // event.preventDefault();
   
  }
  }

  const aiQuestionsCheckbox = document.getElementById('aiQuestionsCheckbox');
  const clientQuestionsCheckbox = document.getElementById('clientQuestionsCheckbox');
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const aminInfo = JSON.parse(localStorage.getItem('ai-admin'));
    if (form.checkValidity()) {
     
      if (!aiQuestionsCheckbox.checked && !clientQuestionsCheckbox.checked) {
        setSuccess('Please select at least one checkbox.');
        return;
      }
      if ( clientQuestionsCheckbox.checked) {
        if(!candidate.recruiterQuestions.trim()){
          setSuccess('Please Enter at least one Question.');
        return;
        }
      }if(candidate.phoneNumber.length > 0){
        if(candidate.phoneNumber.length < 10 || candidate.phoneNumber.length > 10){
          
          setSuccess('Please enter 10 digit phone number');
          return;
        }
      }
      setLoading(true);
      //Redirect to tech selector
      const payload = {
        "op":"ai_questions",
        "candidate_email": candidate.email.toLowerCase(),
        "candidate_name": candidate.name,
        "candidate_phone_no": candidate.phoneNumber,
        "candidate_country_code": candidate.countryCode,
        "user_id": aminInfo.user_id,//"adm-81128172231"
        "recruiter_questions":candidate.recruiterQuestions,
        "job_rec_id":candidate.jobId
      };
      if (document.getElementById('clientQuestionsCheckbox').checked) {
        payload.op = "recruiter_questions";
      }
      if (document.getElementById('aiQuestionsCheckbox').checked) {
        payload.op = "ai_questions";
      }
      if((document.getElementById('clientQuestionsCheckbox').checked && document.getElementById('aiQuestionsCheckbox').checked)){
        payload.op = "recruiter_and_ai_questions";
      }
      // return;

      try {
        await postDataLogin('/admin_in/candidate_signup',payload).then(resp => {
          if(resp.statusCode === 200){
            if(resp.message.toLowerCase() === 'success'){
              setLoading(false);
              setSuccess(resp.info);
              if(candidate.jobId !==""){
                localStorage.setItem("jobId",candidate.jobId)
              }
            
              setCandidate({
                name: '',
                email: '',
                countryCode: '+1',
                phoneNumber: '',
                jobId:''
              });
              if(clientQuestionsCheckbox.checked && !aiQuestionsCheckbox.checked){
                navigate(`/link-generator?id=${resp.dataJ.test_id}`);
              }else{
                navigate(`/techselect?id=${resp.dataJ.candidate_id}`);
              }
            }else{
              setLoading(false);
              setSuccess(resp.info); 
            }
         
          }else if(resp.statusCode === 500){
            setLoading(false);
              setSuccess(resp.info);        
          }else{
            setLoading(false);
            setSuccess('Login failed. Please check your credentials.');
          }
        }).catch((error) => {
          setLoading(false);
          setSuccess('Login failed. Please check your credentials or Network Error');
          console.log('network error:', error);

        });
      } catch (error) {
        setLoading(false);
        console.error('Login failed', error);
      }
      
    } else {
      setValidated(true);
    }
  };
  
  const changeInputValue = (e) =>{
    setInputJobValue(e.target.value)
  }

//   const userlist = [
//     {
//     "email": "ashwath@your-buddy.com",
//     "name": "dls",
//     "phoneNumber": "6149669662",
//     "address": "warangal",
//   },   {
//     "email": "ashwath@your-buddy.com",
//     "name": "dls",
//     "phoneNumber": "6149669662",
//     "address": "warangal",
//   }
// ]
  const getcandidateDetails =async(e)=>{
    e.preventDefault();
    setDataList([]);
    setSuccess('');
    const orgID =localStorage.getItem('org_id')
      const payload ={
        "op":"job_id_input",
        "job_rec_id":orgID+inputJobValue,
       
      };
      setLoading(true)
      try {
        await  postDataLogin('/admin_in/candidate_dashbord',payload).then(resp => {
          if(resp.statusCode === 200){
            if(resp.message.toLowerCase() === 'success'){
              
              setDataList(resp.dataJ);
              setLoading(false);
              //setSuccess(resp.info);
            }else{
              setLoading(false);
              setSuccess(resp.info); 
            }
         
          }else if(resp.statusCode === 500){
            setLoading(false);
              setSuccess(resp.info);        
          }else{
            setLoading(false);
            setSuccess('DashbordDetails failed. Please check your credentials.');
          }
        }).catch((error) => {
          setLoading(false);
          setSuccess('DashbordDetails failed. Please check your credentials or Network Error');
          console.log('network error:', error);
  
        });
      } catch (error) {
        setLoading(false);
        // Handle login error, e.g., display an error message to the user.
        console.error('Login failed', error);
      }
      

 
  };
  // },[])


  const downloadtestDetails= async(event)=>{
    if(candidate.overall_avg_score==="Not available"){
     
      return
    }
    console.log("clicked",event)
    const payload ={
      "op":"s3_presigned_link",
      "test_id":event
    }
    
    setLoading(true)
    try {
      await postDataLogin('/admin_in/candidate_dashbord',payload).then(resp => {
       if(resp.statusCode === 200){
         if(resp.message.toLowerCase() === 'success'){
          
          const fileUrl =resp.dataJ.presigned_url
        
          const link = document.createElement('a');
          link.href = fileUrl;
         

          document.body.appendChild(link);
          link.click();

        document.body.removeChild(link);
          setLoading(false);
          
         }else{
           setLoading(false);
           setSuccess(resp.info); 
         }
      
       }else if(resp.statusCode === 500){
         setLoading(false);
           setSuccess(resp.info);        
       }else{
         setLoading(false);
         setSuccess('DashbordDetails failed. Please check your credentials.');
       }
     }).catch((error) => {
       setLoading(false);
       setSuccess('DashbordDetails failed. Please check your credentials or Network Error');
       

     });
   } catch (error) {
     setLoading(false);
     console.error('Login failed', error);
   }
  }

  const sortedData = dataList.sort((a, b) => (parseFloat(b.overall_avg_score) || 0) - (parseFloat(a.overall_avg_score) || 0));


  return (
    <div className='dashboard-div'  style={{overflowX:'hidden'}}>
       <NavHeader></NavHeader>
      <></>
       {/* <div className="dashboard">
       <h1 className="heading">Dashboard</h1>
       <div className='button-div'>
        <Button className="logout-button" variant="dark" onClick={handleHome}> <FaHome /> Home</Button>
         <Button className="logout-button" variant="dark" onClick={handleLogout}> <FaSignOutAlt /> Logout</Button>
         
      </div>
       </div> */}
       <div >
       <div className='tech-heading-div'>
       <h2 className='cand-title' style={{paddingTop:'25px'}}>Dashboard</h2>
      </div>
       <Row className='m-5'>
        <Col xs={12} sm={8} md={6} lg={4}>
        <InputGroup className="mb-3 input-field">
        <Form.Control
        type="text"
        name="jobId"
        placeholder="Enter Job Id"
        aria-label="Recipient's username"
          aria-describedby="basic-addon2"
          onChange={changeInputValue}
        />
        <Button type="submit" className='search-button' variant='dark' onClick={getcandidateDetails}>Search</Button>
      </InputGroup>
      </Col>
       </Row>
      
      <Row className='tables-div'>
        <Col>
        {success && <Alert variant="danger">{success}</Alert>}
        {loading && (
                  <div className="spinner-overlay">
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
        )}
        {dataList.length > 0 &&
        <div className="table-responsive">
        <Table striped bordered hover>
            <thead>
              <tr>
                <th>S.NO</th>
                <th>Name</th>
                <th>Email</th>
                <th>Comprehensive Score</th>
                {/* <th>TestID</th> */}
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((candidate, index) => (
                <tr key={index}>
                  <td>{index+1}</td>
                  <td>{candidate.candidate_name}</td>
                  <td>{candidate.candidate_email}</td>
                  <td>{candidate.overall_avg_score}</td>
                  {/* <td>{candidate.test_id}</td> */}
                  <td>
                      {candidate.overall_avg_score === "Not available" ? (
                        <FaDownload style={{ opacity: '0.1' }} />
                      ) : (
                        <FaDownload
                          type="submit"
                          onClick={() => downloadtestDetails(candidate.test_id)}
                        />
                      )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          </div>}
        </Col>
      </Row>
      
      
      
      </div>
    </div>
  );
};

export default DashboardPage;
// export default DashboardPage;
